<template lang="pug">
AppDialog(
  title="Import job sites"
  :show="show"
  append-to-body
  @close="close"
)
  AppFileImport(
    :file-types="fileTypes"
    :loading="loading"
    :mime-types="mimeTypes"
    :template-url="templateUrl"
    :organization-id="organizationId"
    :file-params="fileParams"
    resource-type="job_site"
    @upload-file="upload"
    @remove-file="remove"
    @is-loading="onIsLoading"
    @close="close"
  )
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import { uploadFile, removeFile } from '~/utils/file_utils';
import * as types from '../../stores/JobSiteStore/types';
import { JOB_SITE_FILE_IMPORT_TEMPLATE_URL } from '~/app_constants';

export default {
  name: 'JobSiteImportDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState({
      fileParams: 'file_params',
      fileImportLoading: 'file_import_loading',
      importTemplateUrl: 'import_template_url',
    }),
    ...mapGetters(['organizationId', 'mimeTypes', 'fileTypes']),
    loading() {
      return !!this.fileImportLoading;
    },
    templateUrl() {
      return JOB_SITE_FILE_IMPORT_TEMPLATE_URL;
    },
  },
  methods: {
    ...mapMutations({
      setLoading: types.SET_UPLOAD_LOADING,
    }),
    close() {
      removeFile(this, types);
      this.$emit('close-import');
    },
    upload(file) {
      this.setLoading(true);
      uploadFile(this, file, types).catch((e) => {
        this.setLoading(false);
        this.$appMessage(e.message);
      });
    },
    remove() {
      this.setLoading(true);
      removeFile(this, types);
      this.setLoading(false);
    },
    onIsLoading(val) {
      this.setLoading(val);
    },
  },
};
</script>
